import React from "react";
import styled from "@emotion/styled";

const CardBidangLayout = styled.div`
  position: relative;
  overflow: hidden;
  margin: 0 12px;
`;

const BgImage = styled.div`
  margin-bottom: 48px;

  img {
    display: block;
    width: 100%;
    border-radius: 4px;
  }
`;

const Description = styled.div`
  background: #ffffff;
  border-radius: 4px;
  color: #000000;
  bottom: 0;
  left: 0;
  width: calc(100% - 32px);
  overflow: hidden;
  padding: 16px;
  position: absolute;

  h4 {
    margin: 0;
    font-family: ${props => props.theme.fonts.subheading};
    text-transform: capitalize;
    font-size: 20px;
  }

  h3 {
    margin: 0;
    font-family: ${props => props.theme.fonts.subheading};
    font-size: 16px;
    font-weight: normal;
  }
`;

export default function SeminarCard(props) {
  return (
    <CardBidangLayout>
      <BgImage>
        <img src={props.image} alt={props.title} />
      </BgImage>
      <Description tabIndex={0}>
        <h4>{props.name}</h4>
        <h3>{props.desc}</h3>
      </Description>
    </CardBidangLayout>
  );
}
